"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CrossCheck_exports = {};
__export(CrossCheck_exports, {
  default: () => CrossCheck_default
});
module.exports = __toCommonJS(CrossCheck_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.3008 13.9609C11.1966 13.8568 11.138 13.7396 11.125 13.6094C11.125 13.4661 11.1771 13.3424 11.2812 13.2383L14.0156 10.25L12.6094 8.84375L13.332 8.14062L14.6797 9.50781L17.5703 6.32422C17.6615 6.22005 17.7786 6.16797 17.9219 6.16797C18.0651 6.15495 18.1823 6.20052 18.2734 6.30469C18.3776 6.39583 18.4297 6.51302 18.4297 6.65625C18.4427 6.78646 18.4036 6.90365 18.3125 7.00781L15.3828 10.2109L18.3906 13.2383C18.4818 13.3294 18.5273 13.4466 18.5273 13.5898C18.5273 13.7201 18.4818 13.8372 18.3906 13.9414C18.2865 14.0326 18.1628 14.0781 18.0195 14.0781C17.8893 14.0781 17.7721 14.0326 17.668 13.9414L14.7188 10.9531L12.0039 13.9219C11.9128 14.026 11.7956 14.0846 11.6523 14.0977C11.5221 14.0977 11.4049 14.0521 11.3008 13.9609ZM13 7.00781C13.0911 6.90365 13.1302 6.78646 13.1172 6.65625C13.1172 6.51302 13.0716 6.39583 12.9805 6.30469C12.8763 6.21354 12.7526 6.16797 12.6094 6.16797C12.4792 6.16797 12.3685 6.22005 12.2773 6.32422L6.08594 12.8672L3.11719 9.78125C3.01302 9.67708 2.88932 9.625 2.74609 9.625C2.61589 9.625 2.4987 9.67057 2.39453 9.76172C2.30339 9.86589 2.2513 9.98958 2.23828 10.1328C2.23828 10.263 2.29036 10.3737 2.39453 10.4648L5.73438 13.9219C5.78646 13.974 5.83854 14.013 5.89062 14.0391C5.95573 14.0651 6.02734 14.0781 6.10547 14.0781C6.17057 14.0781 6.22917 14.0651 6.28125 14.0391C6.34635 14.013 6.40495 13.974 6.45703 13.9219L13 7.00781Z",
      fill: "currentColor"
    }
  )
);
const SvgCrossCheck = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CrossCheck_default = SvgCrossCheck;
